import { GameContext } from '../../../contexts/GameContext';
import { Line } from 'rc-progress';
import React, { useContext } from 'react';

export default function ZdarProgressBar() {
    const { currentStep, lastStep } = useContext(GameContext);

    const percent = Math.floor((currentStep * 100) / lastStep);
    return (
        <React.Fragment>
            {currentStep < 37 && (
                <div className="progressbar-wrapper">
                    <Line percent={percent} strokeWidth={1} strokeColor="#23ab70" />
                </div>
            )}
        </React.Fragment>
    );
}
